import React from "react";

export const Chip = ({ active, onClick, children, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`px-2.5 py-1 rounded-sm border font-mono text-[10px] uppercase tracking-wide transition-colors ${
      active
        ? "bg-fij-green/10 border-fij-green/40 text-fij-green"
        : "border-fij-border text-fij-textDim hover:text-fij-green hover:border-fij-green/40"
    }`}
  >
    {children}
  </button>
);

export const ChipRow = ({ items, active, onSelect, testIdPrefix, getKey, getLabel }) => (
  <div className="mt-1.5 flex flex-wrap gap-1.5">
    {items.map((item) => {
      const key = getKey ? getKey(item) : item;
      const label = getLabel ? getLabel(item) : item;
      return (
        <Chip
          key={key}
          testId={`${testIdPrefix}-${String(key).replace(/\s+/g, "-")}`}
          active={active === key}
          onClick={() => onSelect(key)}
        >
          {label}
        </Chip>
      );
    })}
  </div>
);
